import * as React from "react";
import throttle from "lodash/throttle";
import { useState, useEffect, useCallback, useRef } from "react";
const WIDGET_ASPECT_RATIO = 10 / 16;
const useUpdateOnResize = ({
  container,
  dimensions,
  setDimensions,
  areDimensionsSet,
  onDimensionsChange
}) => {
  const calculateContainerDimensions = useCallback(
    (isUpdate) => {
      if (!(container == null ? void 0 : container.current)) {
        return {
          width: void 0,
          height: void 0
        };
      }
      const widthKey = isUpdate ? "clientWidth" : "scrollWidth";
      const width = container.current[widthKey];
      return {
        height: width * WIDGET_ASPECT_RATIO,
        width
      };
    },
    [container]
  );
  const propagateDimensions = useCallback(
    (isUpdate) => {
      const newDimensions = calculateContainerDimensions(isUpdate);
      if (dimensions.height !== newDimensions.height || dimensions.width !== newDimensions.width) {
        setDimensions(newDimensions);
        onDimensionsChange(newDimensions);
      }
    },
    [calculateContainerDimensions, dimensions.height, dimensions.width, setDimensions, onDimensionsChange]
  );
  useEffect(() => {
    const onResize = throttle(() => {
      if (areDimensionsSet()) {
        propagateDimensions(true);
      }
    }, 100);
    propagateDimensions(false);
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [propagateDimensions, areDimensionsSet]);
};
const ReportingWidgetContainer = ({ children, onDimensionsChange = () => {
} }) => {
  const [dimensions, setDimensions] = useState({ width: void 0, height: void 0 });
  const container = useRef(null);
  const areDimensionsSet = useCallback(
    () => dimensions.height !== void 0 && dimensions.width !== void 0,
    [dimensions]
  );
  useUpdateOnResize({ container, dimensions, setDimensions, areDimensionsSet, onDimensionsChange });
  return /* @__PURE__ */ React.createElement("div", { ref: container, style: { height: "100%", width: "100%" } }, areDimensionsSet() && children(dimensions));
};
export default ReportingWidgetContainer;
